export default {
  limit: 16,
  maxRecommendedCarouselTabs: 5,
  maxSearchedCarouselTabs: 5,
  maxSubMenuInBottom: 4, // equivale a 5
  displayByPages: [
    { value: 16, text: '16 p/ página' },
    { value: 32, text: '32 p/ página' },
    { value: 48, text: '48 p/ página' },
    { value: 64, text: '64 p/ página' },
    { value: 80, text: '80 p/ página' },
    { value: 96, text: '96 p/ página' },
    { value: 112, text: '112 p/ página' },
    { value: 128, text: '128 p/ página' },
    { value: 144, text: '144 p/ página' },
    { value: 160, text: '160 p/ página' },
  ],
};
